"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrustLogoComponent = void 0;
var React = require("react");
var services_1 = require("@falcon/services");
var TrustLogoComponent = /** @class */ (function (_super) {
    __extends(TrustLogoComponent, _super);
    function TrustLogoComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TrustLogoComponent.prototype.render = function () {
        var baseTrustLogoUrl = "".concat(this.getHost(), "/ttb_searcher/trustlogo?v_querytype=W&v_shortname=SECOV&v_search=").concat(window.location.origin, "&x=6&y=5");
        return (React.createElement("div", null,
            React.createElement("button", { type: "button", className: "trust-logo-btn", onClick: function (event) {
                    event.preventDefault(); // Prevents browser back in journey upon clicking the logo
                    window.open(baseTrustLogoUrl, 'tl_wnd_credentials' + new Date().getTime());
                }, "aria-label": "Open Trust Seal" },
                React.createElement("img", { src: "/".concat(services_1.resourcesHelper.THEME, "/img/sectigo_trust_seal.png"), alt: "Trust Seal" }))));
    };
    TrustLogoComponent.prototype.getHost = function () {
        var locationProtocol = window.location.protocol;
        return locationProtocol === "https:"
            ? "".concat(locationProtocol, "//secure.trust-provider.com")
            : "".concat(locationProtocol, "//www.trustlogo.com");
    };
    return TrustLogoComponent;
}(React.Component));
exports.TrustLogoComponent = TrustLogoComponent;
//# sourceMappingURL=TrustLogoComponent.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/TrustLogoComponent.js
// module id = 1071
// module chunks = 0